import BRANDS, { type BrandName } from "@elit-hair/brands";

/**
 * Maps an organization ID to its corresponding brand key.
 * @param orgId - The Zoho organization ID.
 * @returns The brand key ('elithair', 'biohair', 'rhinomedica', 'yessmile', etc.) or undefined if not found.
 */
export function getBrandFromOrgId(orgId: string | undefined): BrandName | undefined {
    if (!orgId) return undefined;

    const brandEntry = Object.entries(BRANDS).find(([, brandData]) => brandData.zohoOrganizationId === orgId);

    return brandEntry ? (brandEntry[0] as BrandName) : undefined;
}
